import { render, staticRenderFns } from "./statusCode.vue?vue&type=template&id=5306a3cd&scoped=true&"
import script from "./statusCode.vue?vue&type=script&lang=js&"
export * from "./statusCode.vue?vue&type=script&lang=js&"
import style0 from "./statusCode.vue?vue&type=style&index=0&id=5306a3cd&scoped=true&lang=css&"
import style1 from "./statusCode.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5306a3cd",
  null
  
)

export default component.exports